export default function ProgramCardSkeleton({ featured = false }: { featured?: boolean }) {
  return (
    <div
      className={`rounded-2xl p-7 animate-pulse flex flex-col ${
        featured
          ? 'bg-[#7c3aed]/40 md:-translate-y-3'
          : 'bg-[#0f0f1a] border border-white/[0.07]'
      }`}
    >
      <div className="w-10 h-10 rounded-lg bg-white/[0.10] mb-6" />
      <div className="w-20 h-4 rounded bg-white/[0.10] mb-2" />
      <div className="w-3/4 h-5 rounded bg-white/[0.10] mb-2" />
      <div className="w-full h-4 rounded bg-white/[0.08] mb-1" />
      <div className="w-5/6 h-4 rounded bg-white/[0.08] mb-5" />
      <div className="w-24 h-3 rounded bg-white/[0.08]" />
    </div>
  )
}
